<div
    class="flex flex-col h-full w-full max-w-md mx-auto border border-gray-200 rounded-lg shadow-lg bg-white overflow-hidden">

    <!-- Header Section -->
    <div class="bg-[#3f51b5] text-white flex items-center justify-between px-4 py-3 relative">
        <h5 class="flex-1 text-center text-lg font-medium leading-none">Select Delivery Date & Slot</h5>
        <button class="absolute right-4 hover:opacity-70 transition-opacity">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
    </div>

    <!-- Scrollable Content Container -->
    <div class="h-[338px] overflow-y-auto bg-gray-50 p-4">

        <!-- Date Picker Card -->
        <div class="bg-white rounded shadow-sm border border-gray-200 p-4 mb-4">
            <div class="relative border-b border-gray-300 focus-within:border-blue-600 transition-colors">
                <label class="block text-[10px] text-gray-500 uppercase tracking-wide">Delivery Date</label>
                <div class="flex items-center">
                    <input type="date" class="w-full py-2 text-sm outline-none bg-transparent appearance-none"
                        placeholder="Delivery Date" [(ngModel)]="product.deliveryDate"
                        min="{{ product.defaultDate | date: 'yyyy-MM-dd' }}"
                        max="{{ product.maxDeliveryDate | date: 'yyyy-MM-dd' }}" (dateChange)="dateChanged()">
                    <!-- Date Icon (matSuffix) -->
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-400 pointer-events-none"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                </div>
            </div>
        </div>

        <div *ngIf="product.deliveryDate" class="flex flex-col space-y-2">

            <label *ngFor="let d of webOrderDeliveryTimeSlotSetup" class="flex items-start p-3 bg-white border border-gray-200 rounded-lg cursor-pointer
                hover:bg-blue-50 transition-colors">

                <!-- Radio -->
                <input type="radio" name="timeslot"
                    class="w-4 h-4 mt-1 text-blue-600 border-gray-300 focus:ring-blue-500" [value]="d.timeSlot"
                    [(ngModel)]="product.deliveryTime" />

                <!-- Content -->
                <div class="ml-3 flex flex-col">
                    <!-- Time Slot -->
                    <span class="text-sm font-medium text-gray-700">
                        {{ d.timeSlot }} hrs
                    </span>

                    <!-- Discount -->
                    <span *ngIf="d.deliveryDiscount > 0" class="text-[11px] font-semibold text-green-600">
                        {{ d.deliveryDiscount }}% Off On Delivery Charge
                    </span>

                    <!-- Premium -->
                    <span *ngIf="d.deliveryPremium > 0" class="text-[11px] font-semibold text-red-600">
                        {{ d.deliveryPremium }}% Extra On Delivery Charge
                    </span>
                </div>

            </label>

        </div>

        <!-- Time Slot Radio Group -->
        <!-- <div *ngIf="product.deliveryDate" class="flex flex-col space-y-2">
            <label
                class="flex items-center p-3 bg-white border border-gray-200 rounded-lg cursor-pointer hover:bg-blue-50 transition-colors">
                <input type="radio" name="timeslot" class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500">
                <div class="ml-3 flex flex-col">
                    <span class="text-sm font-medium text-gray-700">10:00 - 12:00 hrs</span>
                    <span class="text-[11px] font-semibold text-green-600">10% Off On Delivery Charge</span>
                </div>
            </label> -->

        <!-- <label
                class="flex items-center p-3 bg-white border border-gray-200 rounded-lg cursor-pointer hover:bg-blue-50 transition-colors">
                <input type="radio" name="timeslot" class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500">
                <div class="ml-3 flex flex-col">
                    <span class="text-sm font-medium text-gray-700">18:00 - 20:00 hrs</span>
                    <span class="text-[11px] font-semibold text-red-500">20% Extra On Delivery Charge</span>
                </div>
            </label> -->

        <!-- Add more items as needed -->
        <!-- </div> -->
    </div>

    <!-- Footer Action -->
    <div class="h-16 flex items-center justify-center border-t border-gray-100 bg-white">
        <button type="button"
            class="bg-[#3f51b5] hover:bg-[#303f9f] text-white px-10 py-2 rounded shadow-md text-sm font-medium uppercase tracking-wider transition-all active:scale-95"
            (click)="onConfirmClick()">
            Confirm
        </button>
    </div>
</div>